import { InputMaskContent } from './styles';
import { IMaskInputProps } from './types';

function InputMask(props: IMaskInputProps) {
  return <InputMaskContent {...props} />;
}

export default InputMask;
